import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import SignupPage from './pages/SignupPage';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import VideoCallPage from './pages/VideoCallPage';
import SettingsPage from './pages/SettingsPage';
import UploadVideoPage from './pages/UploadVideoPage';
import MyVideosPage from './pages/MyVideosPage';
import VideoPlayerPage from './pages/VideoPlayerPage';
import ContactsPage from './pages/ContactsPage';
import CallHistoryPage from './pages/CallHistoryPage';
import SavedConversationsPage from './pages/SavedConversationsPage';
import ConversationDetailPage from './pages/ConversationDetailPage';
import PaymentWallPage from './pages/PaymentWallPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import AdminPage from './pages/AdminPage';
import MessagesPage from './pages/MessagesPage';
import ChatPage from './pages/ChatPage';
import { Toaster } from 'sonner';
import InstallPrompt from './components/InstallPrompt';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('kaplie_token');
    const userData = localStorage.getItem('kaplie_user');
    
    if (token && userData) {
      setUser(JSON.parse(userData));
    }
    setLoading(false);
  }, []);

  const isSubscribed = user && (user.subscription_status === 'active' || user.subscription_status === 'trialing');

  const PrivateRoute = ({ children }) => {
    if (loading) return <div className="flex items-center justify-center h-screen bg-[#0A0A0C]"><div className="text-white">Loading...</div></div>;
    if (!user) return <Navigate to="/login" />;
    if (!isSubscribed) return <Navigate to="/subscribe" />;
    return children;
  };

  if (loading) {
    return <div className="flex items-center justify-center h-screen bg-[#0A0A0C]"><div className="text-white">Loading...</div></div>;
  }

  return (
    <div className="App">
      <Toaster position="top-center" theme="dark" />
      <InstallPrompt />
      <BrowserRouter>
        <Routes>
          {/* Landing page - ALWAYS accessible */}
          <Route path="/" element={<LandingPage user={user} setUser={setUser} />} />
          
          {/* Auth pages */}
          <Route path="/signup" element={user ? (isSubscribed ? <Navigate to="/dashboard" /> : <Navigate to="/subscribe" />) : <SignupPage setUser={setUser} />} />
          <Route path="/login" element={user ? (isSubscribed ? <Navigate to="/dashboard" /> : <Navigate to="/subscribe" />) : <LoginPage setUser={setUser} />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          
          {/* Payment pages - accessible to logged-in users without subscription */}
          <Route path="/subscribe" element={user ? (isSubscribed ? <Navigate to="/dashboard" /> : <PaymentWallPage user={user} />) : <Navigate to="/login" />} />
          <Route path="/payment-success" element={user ? <PaymentSuccessPage user={user} setUser={setUser} /> : <Navigate to="/login" />} />
          
          {/* App pages (protected - requires login + subscription) */}
          <Route path="/dashboard" element={<PrivateRoute><DashboardPage user={user} setUser={setUser} /></PrivateRoute>} />
          <Route path="/app" element={<PrivateRoute><DashboardPage user={user} setUser={setUser} /></PrivateRoute>} />
          <Route path="/call/:channelName" element={<VideoCallPage user={user} />} />
          <Route path="/settings" element={<PrivateRoute><SettingsPage user={user} setUser={setUser} /></PrivateRoute>} />
          <Route path="/upload-video" element={<PrivateRoute><UploadVideoPage user={user} /></PrivateRoute>} />
          <Route path="/my-videos" element={<PrivateRoute><MyVideosPage user={user} /></PrivateRoute>} />
          <Route path="/video/:videoId" element={<PrivateRoute><VideoPlayerPage user={user} /></PrivateRoute>} />
          <Route path="/contacts" element={<PrivateRoute><ContactsPage user={user} /></PrivateRoute>} />
          <Route path="/call-history" element={<PrivateRoute><CallHistoryPage user={user} /></PrivateRoute>} />
          <Route path="/conversations" element={<PrivateRoute><SavedConversationsPage user={user} /></PrivateRoute>} />
          <Route path="/conversation/:conversationId" element={<PrivateRoute><ConversationDetailPage user={user} /></PrivateRoute>} />
          <Route path="/admin" element={<PrivateRoute><AdminPage user={user} /></PrivateRoute>} />
          <Route path="/messages" element={<PrivateRoute><MessagesPage user={user} /></PrivateRoute>} />
          <Route path="/chat/:userId" element={<PrivateRoute><ChatPage user={user} /></PrivateRoute>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
